module.exports = __webpack_public_path__ + "img/dat_logo_min.ef8ac3fa.png";